import { Search, X } from "lucide-react";

/**
 * A caixa de busca das listas de cadastro que cabem em memória
 * (2026-10-03, pedido da galera de negócio: busca em quase todas as
 * abas de Ajustes).
 *
 * Filtra A CADA TECLA, sem botão — ao contrário da `CatalogSearch` de
 * Canais e Veículos, que vai ao servidor e por isso espera o Enter. A
 * diferença é de tamanho de lista, não de gosto: aqui a lista já chegou
 * inteira (centenas de itens), lá são 14 mil.
 *
 * Quem filtra é quem usa (`filterBySearch`); este componente só segura
 * o texto, mostra quantos sobraram e, quando não sobra nenhum, diz que
 * foi A BUSCA que esvaziou — lista vazia por filtro e cadastro vazio
 * não podem parecer a mesma coisa.
 */
export function ListSearch({
  value,
  onChange,
  placeholder,
  shown,
  total
}: {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
  /** Quantos itens passaram pelo filtro. */
  shown: number;
  /** Quantos existem na lista sem filtro. */
  total: number;
}) {
  const searching = value.trim() !== "";
  return (
    <div className="list-search">
      <div className="list-search-box">
        <Search size={15} aria-hidden="true" />
        <input
          type="search"
          value={value}
          placeholder={placeholder}
          aria-label={placeholder}
          onChange={event => onChange(event.target.value)}
        />
        {searching && (
          <button
            type="button"
            className="list-search-clear"
            aria-label="Limpar busca"
            onClick={() => onChange("")}
          >
            <X size={14} aria-hidden="true" />
          </button>
        )}
      </div>
      {searching && (
        <span className="list-search-count" aria-live="polite">
          {shown === 0
            ? "Nenhum resultado para esta busca"
            : `${shown} de ${total}`}
        </span>
      )}
    </div>
  );
}
